import { ApolloError } from '@apollo/client';
import {
  getGraphQLErrorMachineCode,
  MembershipsConfigErrorCode,
} from 'src/graphql/error-codes/memberships-config-error-codes';

const STRIPE_SETUP_REQUIRED_MESSAGE =
  'Stripe setup is required before memberships can be configured. Go to Settings > Stripe and complete setup.';
const PRICING_SETUP_REQUIRED_MESSAGE =
  'Pricing cannot be created yet because Stripe setup is incomplete. Complete Stripe setup and try again.';

export const DEFAULT_MEMBERSHIPS_CONFIG_ERROR =
  'Something went wrong. Please try again later.';

export function parseMembershipsConfigError(error: ApolloError): string {
  for (const graphQLError of error.graphQLErrors) {
    const machineCode = getGraphQLErrorMachineCode(graphQLError);

    switch (true) {
      case machineCode === MembershipsConfigErrorCode.STRIPE_ACCOUNT_FOR_PARTNER_NOT_FOUND:
      case machineCode === MembershipsConfigErrorCode.PARTNER_DOES_NOT_HAVE_STRIPE_ACCOUNT:
      case graphQLError.message.includes('Could not find Stripe account for partner'):
      case graphQLError.message.includes('Partner does not have a Stripe account'):
        return STRIPE_SETUP_REQUIRED_MESSAGE;
      case machineCode === MembershipsConfigErrorCode.PARTNER_PRICE_POINT_DATA_NOT_FOUND:
      case graphQLError.message.includes(
        'Could not find the necessary data to create a new price point for partner',
      ):
        return PRICING_SETUP_REQUIRED_MESSAGE;
      default:
        break;
    }
  }

  return DEFAULT_MEMBERSHIPS_CONFIG_ERROR;
}
